// extracted by mini-css-extract-plugin
export var main = "main-module--main--ftKhh";